import React from "react";

import { LeafIcon as Leaf, MoreIcon as More, Typography } from "@packages/ds";
import { FormattedMessage, useIntl } from "react-intl";

import Dialog from "ds/Dialog";
import * as Dropdown from "ds/Dropdown";
import { Trigger } from "ds/Dropdown";
import useUrls from "Hooks/useUrls";
import * as O from "src/organization/pages/billing/components/Overview/BillingOverview.styles";

import * as S from "./ProjectRow.style";

interface ProjectRowProps {
  title: string;
  price: string;
  organizationId: string;
  projectId: string;
  subscriptionId: string;
  greenDiscount?: boolean;
}
const ProjectRow = ({
  title,
  price,
  organizationId,
  projectId,
  subscriptionId,
  greenDiscount
}: ProjectRowProps) => {
  const intl = useIntl();

  const [projectBillingUrl, projectSettingsUrl, projectOverviewUrl] = useUrls(
    [
      "organization.project.usageBasedBilling",
      "organization.project.settings",
      "organization.project"
    ],
    { organizationId, projectId, subscriptionId }
  );

  return (
    <>
      <S.ProjectTitleWrapper>
        <Typography.BodyText>{title}</Typography.BodyText>
        {!!greenDiscount && (
          <Dialog
            trigger={
              <O.IconWrapper aria-label="leaf">
                <Leaf color="var(--theme-success-600)" />
              </O.IconWrapper>
            }
            analyticId="green_discount.description"
            title={intl.formatMessage({
              id: "green_discount.title"
            })}
            description={intl.formatMessage({
              id: "green_discount.description"
            })}
          />
        )}
      </S.ProjectTitleWrapper>
      <O.BodyTextSubtle>
        {greenDiscount &&
          intl.formatMessage({ id: "environment_impact.green" })}
      </O.BodyTextSubtle>
      <O.RightText size="medium" weight="regular">
        {price}
      </O.RightText>
      <Dropdown.Root id="project_row">
        <Trigger variant="icon">
          <More />
        </Trigger>
        <Dropdown.Portal>
          <Dropdown.Content align="end">
            <Dropdown.LinkItem to={projectBillingUrl}>
              <FormattedMessage id="organization.billing.breakdown.project_billing" />
            </Dropdown.LinkItem>
            <Dropdown.LinkItem to={projectOverviewUrl}>
              <FormattedMessage id="organization.member.viewProject" />
            </Dropdown.LinkItem>
            <Dropdown.LinkItem to={projectSettingsUrl}>
              <FormattedMessage id="organization.billing.breakdown.project_settings" />
            </Dropdown.LinkItem>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
    </>
  );
};

export default ProjectRow;
